import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-[#050505] pt-24 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back Link */}
        <Link
          to="/"
          data-testid="privacy-back-link"
          className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-[#D4AF37] transition-colors mb-8"
        >
          <ChevronLeft className="w-4 h-4" />
          <span className="font-['Manrope'] text-sm">Retour à l'accueil</span>
        </Link>

        {/* Header */}
        <div className="mb-12">
          <h1 className="font-['Outfit'] text-3xl sm:text-4xl font-bold text-white mb-4">
            Politique de <span className="text-[#D4AF37]">Confidentialité</span>
          </h1>
          <p className="font-['Manrope'] text-[#A1A1AA]">
            SARL LUXEO CAR - Dernière mise à jour : Décembre 2025
          </p>
        </div>

        {/* Content */}
        <div className="card-luxeo p-8 sm:p-10 space-y-8">
          {/* Introduction */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              1. INTRODUCTION
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              La société LUXEO CAR (SARL au capital de 5 000 €, SIRET 989 521 497 00010, dont le siège 
              social est situé 328 Boulevard Paul Raphel, 13730 Saint-Victoret) attache une grande 
              importance à la protection de vos données personnelles et au respect de votre vie privée.
              La présente politique de confidentialité vous informe sur la façon dont nous collectons, 
              utilisons et protégeons vos données personnelles conformément au Règlement Général sur la 
              Protection des Données (RGPD) et à la loi Informatique et Libertés.
            </p>
          </section>

          {/* Responsable du traitement */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              2. RESPONSABLE DU TRAITEMENT
            </h2>
            <div className="font-['Manrope'] text-[#A1A1AA] text-sm space-y-1">
              <p><strong>SARL LUXEO CAR</strong></p>
              <p>328 Boulevard Paul Raphel</p>
              <p>13730 Saint-Victoret</p>
              <p>Email : luxeocar@gmail.com</p>
              <p>Téléphone : 06 20 20 29 96</p>
              <p>SIREN : 989 521 497</p>
            </div>
          </section>

          {/* Données collectées */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              3. DONNÉES PERSONNELLES COLLECTÉES
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Nous collectons les données personnelles suivantes :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li><strong>Données d'identification :</strong> nom, prénom, adresse postale</li>
              <li><strong>Coordonnées :</strong> numéro de téléphone, adresse email</li>
              <li><strong>Données professionnelles :</strong> numéro de carte VTC ou licence Taxi, 
                  numéro de permis de conduire</li>
              <li><strong>Données bancaires :</strong> coordonnées bancaires pour le paiement des loyers</li>
              <li><strong>Données de géolocalisation :</strong> position du véhicule loué (pour les 
                  véhicules équipés de dispositifs de suivi)</li>
              <li><strong>Données d'utilisation :</strong> kilométrage, dates et heures d'utilisation</li>
            </ul>
          </section>

          {/* Finalités */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              4. FINALITÉS DU TRAITEMENT
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Vos données personnelles sont collectées et traitées pour les finalités suivantes :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>Gestion des demandes de location de véhicules</li>
              <li>Exécution et suivi des contrats de location</li>
              <li>Facturation et gestion des paiements</li>
              <li>Gestion de la relation client</li>
              <li>Sécurité des véhicules et prévention des fraudes</li>
              <li>Respect des obligations légales et réglementaires</li>
              <li>Envoi d'informations commerciales (avec votre consentement)</li>
            </ul>
          </section>

          {/* Base légale */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              5. BASE LÉGALE DU TRAITEMENT
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Le traitement de vos données personnelles est fondé sur :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li><strong>L'exécution du contrat :</strong> pour la gestion de votre location de véhicule</li>
              <li><strong>L'intérêt légitime :</strong> pour la sécurité des véhicules et la prévention des impayés</li>
              <li><strong>Le respect d'obligations légales :</strong> pour les déclarations aux autorités compétentes</li>
              <li><strong>Votre consentement :</strong> pour l'envoi de communications commerciales</li>
            </ul>
          </section>

          {/* Destinataires */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              6. DESTINATAIRES DES DONNÉES
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Vos données personnelles peuvent être communiquées aux destinataires suivants :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>Personnel habilité de LUXEO CAR</li>
              <li>Compagnies d'assurance (en cas de sinistre)</li>
              <li>Prestataires de services de paiement</li>
              <li>Autorités administratives et judiciaires (en cas d'infraction ou sur réquisition)</li>
            </ul>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mt-3">
              Vos données ne sont pas transférées en dehors de l'Union européenne.
            </p>
          </section>

          {/* Durée de conservation */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              7. DURÉE DE CONSERVATION
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Vos données personnelles sont conservées pendant les durées suivantes :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li><strong>Données contractuelles :</strong> pendant la durée du contrat puis 5 ans après 
                  la fin de la relation contractuelle</li>
              <li><strong>Données comptables :</strong> 10 ans</li>
              <li><strong>Données de géolocalisation :</strong> 2 mois après la restitution du véhicule</li>
              <li><strong>Demandes de contact :</strong> 3 ans à compter de la demande</li>
            </ul>
          </section>

          {/* Droits des personnes */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              8. VOS DROITS
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li><strong>Droit d'accès :</strong> obtenir la confirmation que vos données sont traitées 
                  et en obtenir une copie</li>
              <li><strong>Droit de rectification :</strong> demander la correction de données inexactes</li>
              <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données dans 
                  certains cas</li>
              <li><strong>Droit à la limitation :</strong> demander la limitation du traitement de vos données</li>
              <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données pour 
                  des raisons légitimes</li>
              <li><strong>Droit de retirer votre consentement :</strong> à tout moment pour les traitements 
                  basés sur le consentement</li>
            </ul>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mt-3">
              Pour exercer ces droits, contactez-nous à : <a href="mailto:luxeocar@gmail.com" 
              className="text-[#D4AF37] hover:underline">luxeocar@gmail.com</a>
            </p>
          </section>

          {/* Sécurité */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              9. SÉCURITÉ DES DONNÉES
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger 
              vos données personnelles contre tout accès non autorisé, modification, divulgation ou 
              destruction. Ces mesures incluent le chiffrement des données sensibles, l'accès restreint 
              aux données personnelles et la formation de notre personnel à la protection des données.
            </p>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              10. COOKIES
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              Notre site web utilise des cookies techniques nécessaires au bon fonctionnement du site.
              Ces cookies ne collectent pas de données personnelles et ne nécessitent pas votre consentement.
              Nous n'utilisons pas de cookies de tracking ou publicitaires.
            </p>
          </section>

          {/* Réclamation */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              11. RÉCLAMATION
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              Si vous estimez que le traitement de vos données personnelles constitue une violation du 
              RGPD, vous avez le droit d'introduire une réclamation auprès de la Commission Nationale 
              de l'Informatique et des Libertés (CNIL) : <a href="https://www.cnil.fr" 
              className="text-[#D4AF37] hover:underline" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>
            </p>
          </section>

          {/* Modification */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              12. MODIFICATION DE LA POLITIQUE
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              Nous nous réservons le droit de modifier la présente politique de confidentialité à tout 
              moment. Toute modification sera publiée sur cette page avec indication de la date de mise 
              à jour. Nous vous encourageons à consulter régulièrement cette page.
            </p>
          </section>

          {/* Contact */}
          <section className="pt-8 border-t border-white/10">
            <h2 className="font-['Outfit'] text-xl font-semibold text-white mb-4">
              Contact
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-4">
              Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, 
              contactez-nous :
            </p>
            <div className="font-['Manrope'] text-[#A1A1AA] text-sm space-y-1">
              <p><strong>SARL LUXEO CAR</strong></p>
              <p>328 Boulevard Paul Raphel</p>
              <p>13730 Saint-Victoret</p>
              <p>Tél : <a href="tel:0620202996" className="text-[#D4AF37] hover:underline">06 20 20 29 96</a></p>
              <p>Email : <a href="mailto:luxeocar@gmail.com" className="text-[#D4AF37] hover:underline">luxeocar@gmail.com</a></p>
              <p>SIREN : 989 521 497</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
